import { useEffect, useState } from "react";
import styles from "./documentation.module.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useProfileRole, useToast } from "../../../helpers/hooks";
import { DocumentationProps } from "../../../interfaces/profile";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ModalValidationDocuments from "../../../components/ModalValidationDocuments/ModalValidationDocuments";

let DOCUMENTATION_TABS = [
    {
        label: "Cédula de identidad",
        id: "identity_card",
        navigate: "identificacion",
        title: "Deberás subir foto de tu cédula, de ambos lados, en formato PNG, JPEG O JPG",
        completed: false
    },
    {
        label: "Liquidaciones de sueldo",
        id: "labor_data",
        navigate: "salario",
        title: "Necesitamos que completes los siguientes datos y adjuntes fotos de las últimas 3 liquidaciones de sueldo",
        completed: false
    },
    {
        label: "Datos bancarios",
        id: "bank_data",
        navigate: "datos_bancarios",
        title: "Añade tus datos bancarios para poder realizar transacciones en la app",
        completed: false
    },
    {
        label: "Referencias",
        id: "references",
        navigate: "referencias",
        title: "Añade dos personas de confianza que serán tus referencias",
        completed: false
    },
];

const Documentation = ({
    user,
    getIsValidDocuments,
    valid,
    cleanIsValidDocuments,
    validation,
    getDocumentsTypes,
    types,
    cleanGetDocumentsTypes
}: DocumentationProps) => {
    const toast = useToast();
    const location = useLocation();
    const navigate = useNavigate();
    const profileRole = useProfileRole();
    const [tabSelected, setTabSelected] = useState<any>();
    const [modalValidation, setModalValidation] = useState<any>({open: false, type: ""});

    useEffect(() => {
        if(valid?.fetching === "failure"){
            toast("Ha ocurrido un error al calcular la validación de su documentación");
            cleanIsValidDocuments();
        }
        if(valid?.fetching === "success"){
            Object.entries(valid?.data?.completed).map(([key, value]: any) => (
                DOCUMENTATION_TABS = DOCUMENTATION_TABS.map((tab: any) => {
                    if(tab?.id === key){
                        return { ...tab, completed: value }
                    }
                    return tab;
                })
            ));
            const someNotCompleted = valid?.data && Object.values(valid?.data?.completed).some((item: any) => !item);
            if(validation?.waiting && someNotCompleted && valid?.data?.completed?.bank_data && valid?.data?.completed?.identity_card && valid?.data?.completed?.labor_data && valid?.data?.completed?.references){
                setModalValidation({open: true, type: "locationFault"});
                return;
            }
            if(validation?.waiting && !someNotCompleted){
                setModalValidation({open: true, type: ""});
            }
            cleanIsValidDocuments();
        }
    }, [valid?.fetching]);

    useEffect(() => {
        if(types.fetching === "failure") cleanGetDocumentsTypes();
        if(types.fetching === "success") cleanGetDocumentsTypes();
    }, [types.fetching]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const tabFounded = DOCUMENTATION_TABS && DOCUMENTATION_TABS.find((tab: any) => location.pathname.includes(`/documentacion/${tab?.navigate}`));
        getDocumentsTypes();
        setTabSelected(tabFounded);
        if(location.pathname.endsWith("/documentacion")){
            navigate("identificacion");
        }
        getIsValidDocuments();
    }, [location]);

    return (
        <>
            <ModalValidationDocuments open={modalValidation?.open} setOpen={setModalValidation} type={modalValidation?.type} />
            {profileRole(user?.profile?.code) === "user" ? (
                <div className={styles.docCard}>
                    <div className={styles.docCardHeader}>
                        <span className={styles.docCardTitle}>{tabSelected?.label}</span>
                        <div className={styles.docCardIcons}>
                            <InfoOutlinedIcon className={styles.infoIcon} />
                            {!tabSelected?.completed && (
                                <ErrorIcon className={styles.warningIcon} />
                            )}
                        </div>
                    </div>
                    <div className={styles.docCardBody}>
                        <p className={styles.docDescription}>{tabSelected?.title}</p>
                        <Outlet />
                    </div>
                </div>
            ) : (
                <Outlet />
            )}
        </>
    );
};
export default Documentation;
